import { Link } from "react-router-dom";
import { Button } from "@/components/uiDir/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/uiDir/avatar";
import { Card, CardContent } from "@/components/uiDir/card";
import { Badge } from "@/components/uiDir/badge";
import { Eye } from "lucide-react";
import { UserProfile } from "@/lib/models/dashboardmodels";

interface ProfileCardProps {
  userProfile: UserProfile;
  getInitials: (name: string) => string;
}

export const ProfileCard = ({ userProfile, getInitials }: ProfileCardProps) => {
  return (
    <Card className="border-0 shadow-lg overflow-hidden">
      <div className="h-20 bg-primary relative" />
      <CardContent className="pt-0 pb-6">
        <div className="flex flex-col items-center -mt-12">
          <Avatar className="h-24 w-24 border-4 border-white shadow-xl">
            <AvatarImage src={userProfile.avatar_url || `https://api.dicebear.com/7.x/avataaars/svg?seed=${userProfile.username}`} />
            <AvatarFallback className="text-xl font-bold">{getInitials(userProfile.full_name)}</AvatarFallback>
          </Avatar>
          <h3 className="font-bold text-lg mt-3 text-center">{userProfile.full_name}</h3>
          <p className="text-sm text-gray-500">@{userProfile.username}</p>
          {userProfile.title && (
            <p className="text-sm text-gray-700 text-center mt-1">{userProfile.title}</p>
          )}
          <Badge className="mt-2 bg-blue-100 text-blue-700">{userProfile.program}</Badge>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-3 gap-3 mt-6 text-center">
          <div>
            <p className="text-2xl font-bold text-gray-900">{userProfile.projects_count}</p>
            <p className="text-xs text-gray-500">Projects</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{userProfile.followers_count}</p>
            <p className="text-xs text-gray-500">Followers</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{userProfile.total_likes}</p>
            <p className="text-xs text-gray-500">Likes</p>
          </div>
        </div>

        <Link to={`/profile/${userProfile.username}`}>
          <Button variant="outline" className="w-full mt-4" size="sm">
            <Eye className="h-4 w-4 mr-2" />
            View Public Profile
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};